module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('title', [_vm._v("我的奖学金-以诺教育")]), _vm._v(" "), _c('div', {
    staticClass: "orderRight"
  }, [_c('h1', {
    staticClass: "orderCenter"
  }, [_vm._v("我的奖学金")]), _vm._v(" "), _c('div', {
    staticClass: "zhScholarship"
  }, [_c('div', {
    staticClass: "zhLeft"
  }, [_c('i', {
    staticClass: "zhJiang"
  }, [_vm._v("我的奖学金")]), _c('span', {
    staticClass: "zhPir"
  }, [_vm._v(_vm._s(_vm.zhTotal))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.timeout),
      expression: "timeout"
    }],
    staticClass: "datalast"
  }, [_vm._v("(" + _vm._s(_vm.TimeOutPrice) + " 元奖学金将于" + _vm._s(_vm.TimeOutTime) + "过期)")])]), _vm._v(" "), _c('div', {
    staticClass: "zhRight"
  }, [_c('div', {
    staticClass: "zhSign"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-outline"
    }
  })], 1), _c('i', {
    staticClass: "zhJiang1"
  }, [_vm._v("奖学金规则")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zhScholarShip),
      expression: "zhScholarShip"
    }],
    staticClass: "zhInformation"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "zhlast"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.zhBurseGetList), function(v) {
    return _c('div', {
      staticClass: "zhMoney"
    }, [_c('span', {
      staticClass: "zhWords1"
    }, [_vm._v(_vm._s(v.date))]), _vm._v(" "), _c('span', {
      class: ("" + (v.price)) > 0 ? 'zhWords1 zhWordAct' : 'zhWords1'
    }, [_vm._v(_vm._s(v.price))]), _vm._v(" "), _c('span', {
      staticClass: "zhWords1"
    }, [_vm._v(_vm._s(v.origin) + " "), (v.indate) ? _c('span', [_vm._v("，有效期：" + _vm._s(v.indate))]) : _vm._e(), (v.order_id) ? _c('span', [_vm._v("，订单号：" + _vm._s(v.order_id))]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "zhhContent"
  }, [_c('Page', {
    attrs: {
      "total": _vm.zhPage.total,
      "page-size": 20
    },
    on: {
      "on-change": _vm.handlePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zhTotal"
  }, [_vm._v("\n              共" + _vm._s(_vm.zhPage.total) + "条记录\n            ")])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("Q")]), _vm._v("怎么获得奖学金？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem1"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("A")]), _vm._v("以诺会员成功报名以诺课程并亲历课程10天后，获赠以诺奖学金。按实缴学费获赠不等金额。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("Q")]), _vm._v("奖学金用来做什么？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem1"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("A")]), _vm._v("可以在报名课程时抵扣学费。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("Q")]), _vm._v("什么是有效期？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem1"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("A")]), _vm._v("您获赠的奖学金会有使用期限。超出期限未使用的将被清零。不可再使用。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhRecord"
  }, [_c('div', {
    staticClass: "zhR"
  }, [_vm._v("全部")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhRecordList"
  }, [_c('span', {
    staticClass: "zhWords"
  }, [_vm._v("日期")]), _vm._v(" "), _c('span', {
    staticClass: "zhWords"
  }, [_vm._v("收入/支出")]), _vm._v(" "), _c('span', {
    staticClass: "zhWords"
  }, [_vm._v("详细信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3545728b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderList/scholarship.vue
// module id = 545
// module chunks = 1